import type { FlatConfig } from 'domain/index';
import type { Metrics } from './types';
import type { Perm } from 'shared/access';

export type RailGroup = 'system' | 'flash' | 'mixed' | 'physical';
export type RailCtx = { metrics: Metrics | null; config: FlatConfig; unit: string; throughputUnit: string };
export type RailTile = {
  id: string; group: RailGroup; label: string;
  value: (ctx: RailCtx) => string;
  unit?: (ctx: RailCtx) => string | undefined;
  hint?: (ctx: RailCtx) => string | undefined;
  tone?: 'default' | 'brand' | 'flash';
  requires: Perm[];
  when?: (ctx: RailCtx) => boolean;
  /** CONF-212: the metric keys this tile reads. When an exec override moved
   *  any of them, the rail shows the tile as Current (real) vs Custom. */
  keys?: string[];
};
export const RAIL_GROUP_LABELS: Record<RailGroup, string> = {
  system: 'System Attributes',
  flash: 'Flash Metrics',
  mixed: 'Mixed Fleet Metrics',
  physical: 'Physical',
};
